// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#VueIframe__Component[data-v-5f0b026c] {\n  position: fixed;\n  z-index: 100;\n  padding: 10px;\n}\n.animation-content[data-v-5f0b026c] {\n  padding: 0;\n  margin: 0;\n  width: 100%;\n  height: 100%;\n  background-color: white;\n  z-index: 1;\n  width: 1100px;\n}\n.animation-content iframe[data-v-5f0b026c] {\n    width: 100%;\n    height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
